/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Merchant } from './Merchant';
import {
    MerchantFromJSON,
    MerchantFromJSONTyped,
    MerchantToJSON,
    MerchantToJSONTyped,
} from './Merchant';

/**
 * 
 * @export
 * @interface FavoriteMerchantsResponse
 */
export interface FavoriteMerchantsResponse {
    /**
     * 
     * @type {Array<Merchant>}
     * @memberof FavoriteMerchantsResponse
     */
    merchants: Array<Merchant>;
}

/**
 * Check if a given object implements the FavoriteMerchantsResponse interface.
 */
export function instanceOfFavoriteMerchantsResponse(value: object): value is FavoriteMerchantsResponse {
    if (!('merchants' in value) || value['merchants'] === undefined) return false;
    return true;
}

export function FavoriteMerchantsResponseFromJSON(json: any): FavoriteMerchantsResponse {
    return FavoriteMerchantsResponseFromJSONTyped(json, false);
}

export function FavoriteMerchantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FavoriteMerchantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'merchants': ((json['merchants'] as Array<any>).map(MerchantFromJSON)),
    };
}

export function FavoriteMerchantsResponseToJSON(json: any): FavoriteMerchantsResponse {
    return FavoriteMerchantsResponseToJSONTyped(json, false);
}

export function FavoriteMerchantsResponseToJSONTyped(value?: FavoriteMerchantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'merchants': ((value['merchants'] as Array<any>).map(MerchantToJSON)),
    };
}

